import api from '@/lib/axios';

function unwrap<T>(r: { data: { data?: T } | T }): T {
  return (r.data as any).data ?? (r.data as T);
}

/** Summary-only — `incomes` has no full CRUD module, matching Finance Report's own read-only access to it. */
export const IncomesApi = {
  /** MIS Report pre-fill bridge — SUM(amount) grouped by raw title (no category concept exists for incomes), for one academic year + calendar month (1-12). Only nonzero titles. */
  monthlySummary: async (academicYearId: string, month: number): Promise<Record<string, number>> =>
    unwrap(await api.get('/school/incomes/monthly-summary', { params: { academicYearId, month } })),
};
